(function stateDefinition() {
    'use strict';
    angular.module('Entities')
        .service('profileCertificateService', [
            'restUrlBuilder', '$injector', '$http', '$q', 'config', 'organizationalUnitService', '$filter', function certificateUserService(restUrlBuilder, $injector, $http, $q, config, organizationalUnitService, $filter) {
                var restUrlBuilder = restUrlBuilder('auth');
                var protocol;
                var port;
                var that = this;

                this.upload = function (certificate, file) {
                    if (certificate == null)
                        throw 'certificate no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: restUrlBuilder.all('profilecertificate').url,
                        method: 'POST',
                        fields: { certificate: JSON.stringify(certificate) },
                        file: file,
                        fileFormDataName: 'certificateFile'
                    });
                };

                this.getByOu = function get(idOu) {
                    return restUrlBuilder.one('profileCertificate', idOu).get();
                };

                this.getConfigPort = function (ouId) {
                    return organizationalUnitService.getConfig(ouId, '#OuConfigCertificateProviders');
                };

                this.certicateLakautPort = function (ouId) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    this.getConfigPort(ouId).then(function (result) {
                        if (!angular.equals(result, {})) {
                            if (protocol && port) {
                                defered.resolve();
                            } else {
                                var httpPortFrom = 9000;
                                var httpPortTo = 9005;
                                if (result['#LakautEmployeeCertificateProviderHttpPortFrom'] && result['#LakautEmployeeCertificateProviderHttpPortTo']) {
                                    httpPortFrom = result['#LakautEmployeeCertificateProviderHttpPortFrom'];
                                    httpPortTo = result['#LakautEmployeeCertificateProviderHttpPortTo'];
                                }
                                var httpsPortFrom = 10000;
                                var httpsPortTo = 10005;
                                if (result['#LakautEmployeeCertificateProviderHttpsPortFrom'] && result['#LakautEmployeeCertificateProviderHttpsPortTo']) {
                                    httpsPortFrom = result['#LakautEmployeeCertificateProviderHttpsPortFrom'];
                                    httpsPortTo = result['#LakautEmployeeCertificateProviderHttpsPortTo'];
                                }

                                var rta = 0;

                                for (var puerto = httpPortFrom; puerto <= httpPortTo; puerto++) {
                                    that.certicateLakautPin("http", puerto).then(function (response) {
                                        defered.resolve();
                                    },
                                        function (error) {
                                            rta++;
                                            if (rta >= 12) {
                                                defered.reject('Verifique que la aplicacion de Token este configurada como servicio.');
                                            }
                                        });
                                }

                                for (var puerto = httpsPortFrom; puerto <= httpsPortTo; puerto++) {
                                    that.certicateLakautPin("https", puerto).then(function (response) {
                                        defered.resolve();
                                    },
                                        function (error) {
                                            rta++;
                                            if (rta >= 12) {
                                                defered.reject('Verifique que la aplicacion de Token este configurada como servicio.');
                                            }
                                        });
                                }
                            }
                        }
                    }, function (error) {
                        if (error.status === 404) {
                            errors.showError('PaycheckConfigNotDefinedError');
                        } else {
                            errors.showError(error);
                        }
                    });

                    return promise;
                };

                this.certicateLakautPin = function (prot, p) {
                    var defered = $q.defer();
                    var promise = defered.promise;
                    var url = prot + '://localhost:' + p + '/ping';

                    $http.get(url).then(function (response) {
                        protocol = prot;
                        port = p;
                        defered.resolve();
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                this.certicateLakautSign = function (urlPdf, outputUrl, ouId) {
                    var encodedInputURL = encodeURIComponent(urlPdf);

                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.certicateLakautPort(ouId).then(function () {

                        var urlFirmador = protocol + "://localhost:" + port + "/signer/Sign?input_url=" + encodedInputURL;

                        var output = outputUrl ? outputUrl : config.apiUrl("GetSharing");

                        var nowAsMillis = new Date().getTime();

                        urlFirmador = urlFirmador + "&input_credential=";
                        urlFirmador = urlFirmador + "&output_url=" + output;
                        urlFirmador = urlFirmador + "&output_credential=&suffix=";

                        urlFirmador = urlFirmador + "&returnMultiPart=true&_=" + nowAsMillis;

                        $http.get(urlFirmador).then(function (response) {
                            if (response.data === 'An unknown error happen during the process') {
                                defered.reject("Error en el proceso de firma de Token. Verifique la configuración del mismo.");
                            }

                            if (response.data === 'No cert selected') {
                                defered.reject("No selecciono ningun certificado valido.");
                            }

                            defered.resolve();
                        }, function (error) {
                            defered.reject(error);
                        });
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                this.certicateLakautMultipleSign = function (arrayUrlPdf, outputUrl, ouId) {
                    if (arrayUrlPdf.length === 0) {
                        return;
                    }
                    var encodedInputURL = "";
                    var input_urls = [];
                    for (var i = 0; i < arrayUrlPdf.length; i++) {
                        input_urls.push(decodeURIComponent(arrayUrlPdf[i]));
                    };

                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.certicateLakautPort(ouId).then(function () {


                        var urlFirmador = protocol + "://localhost:" + port + "/Signer/SignMultiple";

                        var nowAsMillis = new Date().getTime();

                        var output = outputUrl ? outputUrl : config.apiUrl("GetSharing");

                        var postData = {
                            input_urls: input_urls,
                            input_credential: '',
                            output_url: output,
                            output_credential: '',
                            suffix: '',
                            returnMultiPart: true
                        };

                        $http.post(urlFirmador, JSON.stringify(postData), { timeout: 1000000000 }).then(function (response) {
                            if (response.data === 'An unknown error happen during the process') {
                                defered.reject("Error en el proceso de firma de Token. Verifique la configuración del mismo.");
                            }

                            if (response.data === 'No cert selected') {
                                defered.reject("No selecciono ningun certificado valido.");
                            }

                            defered.resolve();
                        }, function (error) {
                            if (error.status === -1 && !error.data) {
                                // Posible 414 request to long,
                                defered.reject("SIGNLAKAUTERROR");
                            } else {
                                defered.reject(error);
                            }
                        });
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };

                this.get = function (filter) {
                    if (!filter) {
                        filter = {};
                    }

                    var parameters = {
                        organizationalUnitId: filter.organizationalUnitId,
                        enabled: filter.enabled,
                        active: filter.active,
                        type: filter.type,
                        signType: filter.signType
                    };

                    return restUrlBuilder.all('ProfileCertificate').get({ params: parameters })
                        .then(function (res) {
                            var lakaut = $filter('filter')(res, function (item) {
                                return item.provider === 'Lakaut';
                            }, true);

                            if (lakaut && lakaut.length > 0) {
                                lakaut[0].provider = 'Token';
                            }
                            return res;
                        });
                };

                this.getAll = function () {
                    return restUrlBuilder.all('ProfileCertificate').get();
                };

                this.downloadCertificate = function (item) {
                    var params = {
                        id: item.id,
                        UserId: item.userId,
                        OrganizationalUnitId: item.organizationalUnitId
                    };

                    return restUrlBuilder.all('ProfileCertificate/DownloadCertificate').put(params);
                };
            }
        ]);
})();